export class DivisionJob {
    id!: string
    divisionId!: string
    jobId!: string
}
